import { createFileRoute } from "@tanstack/react-router";
import { PageHero, PageIntro } from "@/components/site/PageHero";
import { PlansSection } from "@/components/site/PlansSection";
import { Reveal, RevealStagger } from "@/components/site/Reveal";
import { Section } from "@/components/site/Section";
import { whatsappLink } from "@/content/site";
import { useSiteSection } from "@/hooks/useSiteContent";

export const Route = createFileRoute("/planos")({
  head: () => ({
    meta: [
      { title: "Planos de internet fibra óptica — Contato Internet" },
      {
        name: "description",
        content:
          "Planos de 500 Mega a 1 Giga em fibra óptica, com Wi-Fi incluso, +200 canais de TV, App Deezer e instalação grátis.",
      },
      { property: "og:title", content: "Planos de internet fibra óptica — Contato Internet" },
      {
        property: "og:description",
        content: "De 500 Mega a 1 Giga em fibra óptica, com Wi-Fi e instalação grátis.",
      },
    ],
  }),
  component: PlanosPage,
});

function PlanosPage() {
  const internet = useSiteSection("internet");
  return (
    <>
      <PageHero
        eyebrow={internet.eyebrow}
        title={internet.title}
        subtitle={internet.subtitle}
      />
      <PageIntro text={internet.text} />

      <Reveal variant="fade-up">
        <PlansSection hideHeader />
      </Reveal>

      <Section
        reveal
        className="bg-secondary/40"
        eyebrow="O que pode acompanhar seu plano"
        title="Você escolhe a internet, a Contato completa a experiência"
      >
        <RevealStagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" staggerDelay={100}>
          {[
            {
              t: "Instalação grátis",
              d: "Equipe técnica instala e configura tudo, sem custo adicional na maioria dos planos.",
            },
            {
              t: "Wi-Fi incluso",
              d: "Roteador de alta performance para levar o sinal forte por toda a casa.",
            },
            {
              t: "TV Online",
              d: "Canais ao vivo e apps de entretenimento disponíveis como complemento do seu plano.",
            },
            {
              t: "Apps de música",
              d: "Deezer e outros serviços podem ser adicionados conforme a oferta vigente.",
            },
          ].map((i) => (
            <div key={i.t} className="rounded-3xl border border-border bg-card p-7">
              <h3 className="text-lg">{i.t}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{i.d}</p>
            </div>
          ))}
        </RevealStagger>
      </Section>

      <Section
        reveal
        dark
        title="Não achou o plano ideal?"
        text="Montamos uma proposta sob medida para você."
      >
        <div className="text-center">
          <a
            href={whatsappLink("Olá! Gostaria de um plano personalizado da Contato.")}
            target="_blank"
            rel="noreferrer"
            className="inline-flex rounded-full bg-brand-yellow px-8 py-3.5 text-sm font-extrabold uppercase tracking-wide text-brand-yellow-foreground"
          >
            Falar com um consultor
          </a>
        </div>
      </Section>
    </>
  );
}
